export default __webpack_public_path__ + "static/5-5638d7f3af86137cde246763b7f200ea.webp";